import React from 'react'

const HeroSection = () => {
  return (
        <section id='heroSection' className='hero--section'>
          <div className='hero--section--content--box'>
            <div className='hero--section--content'>
              <p className='section--title'>Hey, I'm Sam</p>
              <h1 className='hero--section--title'>
                <span className='hero--section-title--color'>MERN Stack</span>{""}
                <br/>
                Developer
              </h1>
              <p className='hero--section--description'>
              Seasoned MERN architect, building secure, scalable web experiences with user-centric UI and proven performance results. Let's collaborate to elevate your brand with a high-impact digital masterpiece.
              </p>
              </div>
              <a href="My-Resume.pdf" download="My-Resume.pdf">
                <button className='btn btn-primary'>
                    Download Resume
                 </button>
              </a>
              </div>     
              <div className='hero--section--img'>
                <img src='./img/me3.jpeg' alt='Hero'/>
                </div> 
        </section>
  )
}

export default HeroSection